export default "<p>add-lecturers works!</p>\n"